"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "NotificationsTypePolicies", {
  enumerable: true,
  get: function get() {
    return _notifications.default;
  }
});
var _notifications = _interopRequireDefault(require("./notifications"));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJfbm90aWZpY2F0aW9ucyIsIl9pbnRlcm9wUmVxdWlyZURlZmF1bHQiLCJyZXF1aXJlIl0sInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL25vdGlmaWNhdGlvbi1jZW50ZXIvQXBvbGxvL3R5cGUtcG9saWNpZXMvaW5kZXgudHMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IHsgZGVmYXVsdCBhcyBOb3RpZmljYXRpb25zVHlwZVBvbGljaWVzIH0gZnJvbSAnLi9ub3RpZmljYXRpb25zJztcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBQUEsSUFBQUEsY0FBQSxHQUFBQyxzQkFBQSxDQUFBQyxPQUFBIiwiaWdub3JlTGlzdCI6W119